"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChallengeFactory = void 0;
// Components
const otp_1 = require("./otp");
const trusted_1 = require("./trusted");
const trustedLogin_1 = require("./trustedLogin");
const signatureKey_1 = require("./signatureKey");
const otpIvr_1 = require("./otpIvr");
const signatureKeyIvr_1 = require("./signatureKeyIvr");
const types_1 = require("../../../features/authoriser/types");
// getChallenge tiene que recibir el urlConfig o lo debería pasar la clase por constructor
class ChallengeFactory {
    constructor(api, session, manager, urlConfig, eventBus) {
        this.api = api;
        this.session = session;
        this.manager = manager;
        this.urlConfig = urlConfig;
        this.eventBus = eventBus;
    }
    // eslint-disable-next-line complexity
    getChallenge(data) {
        switch (data.type) {
            case types_1.ChallengeType.OTP:
                return new otp_1.MbOtp(this.api, data, this.urlConfig.MbOtp, this.eventBus);
            case types_1.ChallengeType.OTP_LOGIN:
                return new otp_1.MbOtpLogin(this.api, data, this.urlConfig.MbOtpLogin, this.eventBus);
            case types_1.ChallengeType.TRUSTED_CONFIRMATION:
                return new trusted_1.MbTrusted(this.api, data, this.session, this.urlConfig.AsyncConnection, this.urlConfig.MbTrusted, this.eventBus);
            case types_1.ChallengeType.TRUSTED_CONFIRMATION_LOGIN:
                return new trustedLogin_1.MbTrustedLogin(this.api, data, this.session, this.urlConfig.AsyncConnection, this.urlConfig.MbTrustedLogin, this.eventBus);
            case types_1.ChallengeType.SIGNATURE_KEY:
                return new signatureKey_1.MbSignatureKey(this.api, data, this.urlConfig.MbSignatureKey);
            case types_1.ChallengeType.OTP_IVR:
                return new otpIvr_1.MbOtpIvr(this.api, data, this.manager);
            case types_1.ChallengeType.SIGNATURE_KEY_IVR:
                return new signatureKeyIvr_1.MbSignatureKeyIvr(this.api, data, this.manager);
            case types_1.ChallengeType.NONE:
            default:
                return null;
        }
    }
}
exports.ChallengeFactory = ChallengeFactory;
//# sourceMappingURL=challengeFactory.js.map